// pais.js — Helpers de país sin dependencias (los usan el contexto, la
// resolución de variantes de sección, el selector del header y el admin).

// Normaliza para comparar nombres/códigos de país sin acentos ni mayúsculas.
export const normalizarPais = (v) => String(v ?? '')
  .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .trim().toLowerCase();

// Nombre de país → ISO-3166 alfa-2. Sirve para pintar la bandera de un dato que
// se guardó como texto libre (p. ej. `mentor_docentes.pais` o `users.pais`),
// donde no hay código. Cubre Iberoamérica, que es el alcance de la plataforma.
const ISO_POR_NOMBRE = {
  argentina: 'ar', bolivia: 'bo', brasil: 'br', brazil: 'br', chile: 'cl',
  colombia: 'co', 'costa rica': 'cr', cuba: 'cu', ecuador: 'ec',
  'el salvador': 'sv', espana: 'es', 'españa': 'es', spain: 'es',
  guatemala: 'gt', honduras: 'hn', mexico: 'mx', nicaragua: 'ni',
  panama: 'pa', paraguay: 'py', peru: 'pe', portugal: 'pt',
  'puerto rico': 'pr', 'republica dominicana': 'do',
  'estados unidos': 'us', usa: 'us', 'united states': 'us',
  uruguay: 'uy', venezuela: 've', italia: 'it', francia: 'fr',
  alemania: 'de', 'reino unido': 'gb', canada: 'ca',
};

// Devuelve el ISO-2 en minúscula, o null si no se reconoce. Acepta ya un código
// de dos letras y lo deja pasar.
export const isoDePais = (valor) => {
  const v = normalizarPais(valor);
  if (!v) return null;
  if (/^[a-z]{2}$/.test(v)) return v;
  return ISO_POR_NOMBRE[v] || null;
};

// URL de bandera lista para usar: el valor propio si lo hay (emoji aparte),
// o la de flagcdn a partir del nombre/código.
export const urlBandera = (valor, ancho = 80) => {
  const iso = isoDePais(valor);
  return iso ? `https://flagcdn.com/w${ancho}/${iso}.png` : null;
};

export default normalizarPais;
